import ReactPixel from "react-facebook-pixel";
import { sha256 } from "js-sha256";
import dayjs from "dayjs";

import { dynamicConfig } from "../config/dynamicConfigs";
import { Genders, UserDetailsType } from "../types";

const options = {
  autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
  debug: dynamicConfig.analyticsDebug, // enable logs
};

export const FbInit = (data?: ReactPixel.AdvancedMatching) => {
  if (dynamicConfig.allowAnalytics) {
    ReactPixel.init("1360221884444892", data, options);
  }
};

export const FbPixel = dynamicConfig.allowAnalytics ? ReactPixel : null;

export const getFbParams = (details: Partial<UserDetailsType>, phoneNumber = "") => ({
  action_source: "app",
  event_source_url: `https://${window.location.hostname}`,
  event_time: Math.ceil(dayjs().utc().toDate().getTime() / 1000),
  client_user_agent: navigator.userAgent,
  db: dayjs(new Date(details.birthDate || 0))
    .utc()
    .format("YYYYMMDD"),
  fn: sha256((details.firstName || "").toLowerCase().normalize()),
  ln: sha256((details.lastName || "").toLowerCase().normalize()),
  ge: details.gender === Genders.FEMALE ? "f" : "m",
  ph: sha256(phoneNumber.replace("+", "")),
});
